const sushiswap = require("./sushiswap");

const TOKEN_SYMBOL_TO_ADDRESS = {
  SUSHI: "0x6b3595068778dd592e39a122f4f5a5cf09c90fe2",
  DAI: "0x6b175474e89094c44da98b954eedeac495271d0f",
  USDC: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
  USDT: "0xdac17f958d2ee523a2206206994597c13d831ec7",
  WETH: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
  ETH: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
  sETH: "0x5e74c9036fb86bd7ecdcb084a0673efc32ea31cb",
  stETH: "0xae7ab96520de3a18e5e111b5eaab095312d7fe84",
  LINK: "0x514910771af9ca656af840dff83e8264ecf986ca",
  sLINK: "0xbbc455cb4f1b9e4bfc4b73970d360c8f032efee6",
  HBTC: "0x0316eb71485b0ab14103307bf65a021042c6d380",
  WBTC: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
  sBTC: "0xfe18be6b3bd88a2d2a7f928d00292e7a9963cfc6",
  renBTC: "0xeb4c2781e4eba804ce9a9803c67d0893436bb27d",
  BBTC: "0x9be89d2a4cd102d8fecc6bf9da793be995c22541",

  CRV: "0xd533a949740bb3306d119cc777fa900ba034cd52",
  CVX: "0x4e3fbd56cd56c3e72c1403e103b45db9da5b9d2b",
  LDO: "0x5a98fcbea516cf06857215779fd812ca3bef1b32",
  ALCX: "0xdbdb4d16eda451d0503b854cf79d55697f90c8df",

  "3Crv": "0x6c3f90f043a72fa612cbac8115ee7e52bde6e490",
  crvRenWSBTC: "0x075b1bb99792c9e1041ba13afef80c91a1e70fb3",
  "bBTC/sbtcCRV": "0x410e3e86ef427e30b9235497143881f717d93c2a",
  alUSD: "0xbc6da0fe9ad5f3b0d58160288917aa56653660e9"
};

const TOKEN_ADDRESS_TO_SYMBOL = Object.entries(TOKEN_SYMBOL_TO_ADDRESS).reduce((prev, curr) => ({
  ...prev,
  [curr[1]]: curr[0]
}), {});

const TOKEN_ADDRESS_TO_DECIMALS = {
  [TOKEN_SYMBOL_TO_ADDRESS.DAI]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.USDC]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.USDT]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.WETH]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS["3Crv"]]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.ETH]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.sETH]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.stETH]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.LINK]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.sLINK]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.HBTC]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.WBTC]: 8,
  [TOKEN_SYMBOL_TO_ADDRESS.sBTC]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.renBTC]: 8,
  [TOKEN_SYMBOL_TO_ADDRESS.BBTC]: 8,
  [TOKEN_SYMBOL_TO_ADDRESS.SUSHI]: 18,

  [TOKEN_SYMBOL_TO_ADDRESS.CRV]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.CVX]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.LDO]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.ALCX]: 18,
  
  [TOKEN_SYMBOL_TO_ADDRESS["3Crv"]]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.crvRenWSBTC]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS["bBTC/sbtcCRV"]]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.alUSD]: 18
};

const PREFERRED_SWAP_PATH_TOKEN_ADDRESS = TOKEN_SYMBOL_TO_ADDRESS.WETH;
const NATIVE_TOKEN = TOKEN_SYMBOL_TO_ADDRESS.WETH;

module.exports = {
  TOKEN_ADDRESS_TO_DECIMALS,
  TOKEN_SYMBOL_TO_ADDRESS,
  TOKEN_ADDRESS_TO_SYMBOL,
  PREFERRED_SWAP_PATH_TOKEN_ADDRESS,
  UNIV2_ROUTER_ADDRESS: "0xd9e1ce17f2641f24ae83637ab66a2cca9c378b9f",
  NATIVE_TOKEN,
  PROTOCOLS: {
    sushiswap,
  }
};
